import { useCallback } from 'react';

import { namedOperations } from '@/pages/Workspace/sections-legacy/Models/__generated__/queries.generated';

import { useDeleteModelMutation } from './__generated__/mutations.generated';

export default function useDeleteModel(): (modelId: string) => Promise<void> {
  const [deleteModelMutation] = useDeleteModelMutation();

  return useCallback(
    async (modelId: string) => {
      await deleteModelMutation({
        variables: { modelId },
        refetchQueries: [namedOperations.Query.Models],
      });
    },
    [deleteModelMutation],
  );
}
